<template>
  <div v-if="display">
    <div class="navigation--top">
      <div class="container">
        <div class="row">
          <div class="col-1">
            <div class="navigation--top-logo">
              <Logo />
            </div>
          </div>
          <div class="col-10 hide--mobile">
            <div class="navigation--top-links" id="links">
              <router-link class-activex="navigation--top-link-active" class="navigation--top-link text--small" :to="{ name: 'home', params: { param: null } }">
                <span class="navigation--top-label">Dashboard</span>
              </router-link>
              <router-link class-activex="navigation--top-link-active" class="navigation--top-link text--small" :to="{ name: 'submissions', params: { param: null } }">
                <span class="navigation--top-label">Submissions</span>
              </router-link>
              <router-link class-active="navigation--top-link-active" class="navigation--top-link text--small" :to="{ name: 'contests', params: { param: null } }">
                <span class="navigation--top-label">Contests</span>
              </router-link>

              <router-link class-active="navigation--top-link-active" class="navigation--top-link text--small" :to="{ name: 'billing',       params: { param: null } }">
                <span class="navigation--top-label">Billing</span>
              </router-link>
              
              <router-link class-active="navigation--top-link-active" class="navigation--top-link text--small" :to="{ name: 'settings', params: { param: null } }">
                <span class="navigation--top-label">Settings</span>
              </router-link>

              <a class="navigation--top-link text--small" href="#"><span class="navigation--top-label" @click="logout()">Log out</span></a>

            </div>
          </div>
          <div class="col-1">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Logo from "../components/Logo";
  import axios from "axios";
  export default {
    name: "Navigation",
    components: {
      Logo
    },
    methods: {
      changeOrg(event) {
        this.selected = event.target.value;
        this.$globals.organization = event.target.value;
        this.$forceUpdate();

        console.log("ding: " + this.$globals.organization_id);
      },
      logout() {
        var self = this;

        this.$store.dispatch('logout')
          .then(() => {
            self.$router.push('/login');
          })
          .catch(err => {
            console.log(err);
            self.isLoading = false;
          })

        localStorage.removeItem('token');
        this.$router.push('/login');
      },
      getBillingUrl() {
        var self = this;
        axios({
            method: "GET",
            crossdomain: true,
            headers: {
              "Content-Type": "Content-Type:application/json"
            },
            url: "/subscription/billing",
          })
          .then(function(response) {
            console.log(response.data);
            self.billingUrl = response.data.billingUrl;
            self.isLoading = false;
            window.location = response.data.billingUrl;
          })
          .catch(function(error) {
            self.errors = error.response.data;
            self.isLoading = false;
          });
      }

    },
    data() {
      return {
        billingUrl: '',

        attributes: {
          ref: "openIndicator",
          role: "presentation",
          class: "vs__open-indicator",
        },
      };
    },
    props: {
      display: {
        type: Boolean,
        default: true,
      },
    },
    mounted() {},
  };
</script>

<style>
  #mobileAuthNavBar {
    min-height: 125px;
    justify-content: space-between;
  }
</style>